class OpalWoocommerceSingleProduct {
    constructor() {
        this.initSlideProduct();
        $('.woocommerce-product-gallery').on('wc-product-gallery-after-init', () => {
            this.singleProductGalleryImages();
        });
    }

    initSlideProduct() {
        let lightbox = $('.single-product .woocommerce-product-gallery__image > a');
        if (lightbox.length) {
            lightbox.attr("data-elementor-open-lightbox", "no");
        }
    }

    singleProductGalleryImages() {
        var rtl = $('body').hasClass('rtl') ? true : false,
            $gallery = $('.woocommerce-single-style-1 .woocommerce-product-gallery');

        if ($gallery.length < 0) {
            return;
        }

        let data_gallery = $gallery.data('columns'),
            $gallery_child = $('.flex-control-thumbs', $gallery);

        if ($gallery_child.children().length > data_gallery) {
            $gallery_child.slick({
                rtl: rtl,
                infinite: false,
                slidesToShow: data_gallery,
                vertical: true,
                verticalSwiping: true,
            });
        }

    }
}

new OpalWoocommerceSingleProduct();